import { datadogLogs } from '@datadog/browser-logs';

function validateError(error: unknown): Error {
  if (error instanceof Error && error.message) {
    return error;
  }

  return new Error('Unknown error');
}

export function logError(
  error: Error | string,
  level: 'error' | 'fatal',
  tags?: Record<string, unknown>
) {
  if (typeof error === 'string') {
    datadogLogs.logger.error(error, { level });
  } else {
    datadogLogs.logger.error(error.message, { level, tags }, error);
  }
}

export function logGameLoadFailure(error: Error) {
  logError(validateError(error), 'fatal', { context: 'GAME_LOAD_FAILURE' });
}

export function logClientError(error: Error) {
  logError(validateError(error), 'error');
}

type Breadcrumb = {
  category: string;
  message: string;
  level?: 'debug' | 'info' | 'warning' | 'error';
  data?: Record<string, unknown>;
};

export function logBreadcrumb({
  category,
  message,
  level,
  data,
}: Breadcrumb) {
  datadogLogs.logger.log(message, {
    level,
    tag: 'breadcrumb',
    category,
    ...data,
  });
}
